import Vue from 'vue';

// Header and sidebar are siblings rendered per-view, so there is no shared parent
// to hold the drawer state. This bus is the channel between them.
export const sidebarBus = new Vue();

export default class SidebarService{

  open(){
    sidebarBus.$emit('sidebar:set', true);
  }

  close(){
    sidebarBus.$emit('sidebar:set', false);
  }

  toggle(){
    sidebarBus.$emit('sidebar:toggle');
  }
}
